export default __webpack_public_path__ + "static/media/figo-logo.a2ea4f42.svg";